import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { formatDateFromUTC } from "../../components/utils/FormatDateFromUTC";
import { formatHourFromUTC } from "../../components/utils/FormatHourFromUTC";
import Avatar from "@mui/material/Avatar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import Button from "@mui/material/Button";

// prettier-ignore
import { Box, Card, CardContent, CardHeader, List, Paper, Chip} from "@mui/material";

export const NotificationDetail = ({ notificationId, notificationInfo }) => {
  const history = useHistory();

  return (
    <Box sx={{ maxWidth: 650 }}>
      {console.log(notificationInfo)}
      <Card sx={{ mb: 2 }}>
        <Paper>
          <CardHeader
            avatar={
              <Avatar
                aria-label="notification"
                sx={{ width: 42, height: 42, ml: 2 }}
              >
                <NotificationsIcon />
              </Avatar>
            }
            title={`Notificación ${notificationId}`}
            subheader={`${formatDateFromUTC(notificationInfo.created)} por ${
              notificationInfo.create_user
            }`}
          ></CardHeader>
          <CardContent>
            <List dense={true} sx={{ pb: 0 }}>
              <Alert
                severity={notificationInfo.category == 0 ? "info" : "warning"}
              >
                <AlertTitle>
                  <b>{notificationInfo.title}</b>
                </AlertTitle>
                <div>{notificationInfo.msg}</div>
                <div style={{ marginTop: "6px" }}>
                  <small>
                    <i>
                      {formatDateFromUTC(notificationInfo.start_date)} -{" "}
                      {formatHourFromUTC(notificationInfo.start_date)}
                    </i>
                  </small>
                </div>
              </Alert>
            </List>
          </CardContent>
        </Paper>
      </Card>

      <Button
        onClick={() => {
          history.push("/notifications");
        }}
        startIcon={<ArrowBackIcon />}
      >
        Volver
      </Button>
    </Box>
  );
};
